import React from 'react';
import Chart from "react-google-charts";
import './insight.styles.scss';
import Loader from 'react-loader-spinner';
import DataGrid from './../table/datagrid.component';
import { sortObjectArrayDesc } from '../../utils/helper';
import { worldColumns, usaColumns } from '../../utils/grid.utils';


class Insight extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoaded: false
    }
  }

  async loadData() {
    try {
      let url = 'https://corona.lmao.ninja/v2/countries?sort=cases';

      if (this.props.param) {
        url = 'https://corona.lmao.ninja/v2/states';
      }

      const res = await fetch(url);
      let data = await res.json();

      if (this.props.param) {
        data = data.map(d => ({
          ...d,
          recovered: d.cases - d.deaths - d.active
        }));
      }

      this.setState({
        data: data,
        isLoaded: true
      });

    } catch (e) {
      console.log(e);
    }
  }

  componentDidMount() {
    this.loadData();
  }

  render() {
    const { param } = this.props;
    let conChart = <Loader
      type="Circles"
      color="#00BFFF"
      height={100}
      width={100}
    />;

    let detChart = <Loader
      type="Circles"
      color="#00BFFF"
      height={100}
      width={100}
    />;

    let recChart = <Loader
      type="Circles"
      color="#00BFFF"
      height={100}
      width={100}
    />;

    if (this.state.isLoaded) {
      const topConfirmed = sortObjectArrayDesc(this.state.data, 'cases', 3);
      const topDeaths = sortObjectArrayDesc(this.state.data, 'deaths', 3);
      const topRecovered = sortObjectArrayDesc(this.state.data, 'recovered', 3);

      if (topConfirmed && topConfirmed.length > 0) {
        const dataArray = [];
        topConfirmed.forEach(elem => {
          if (elem.cases) {
            if (param && param === 'US') {
              dataArray.push([elem.state, elem.cases, '#3f7fff']);
            } else {
              dataArray.push([elem.country, elem.cases, '#3f7fff']);
            }
          }
        });

        if (dataArray.length > 0) {
          if (param && param === 'US') {
            dataArray.unshift(['State', 'Cases', { role: 'style' }]);
          } else {
            dataArray.unshift(['Country', 'Cases', { role: 'style' }]);
          }
        }

        if (dataArray.length > 2) {
          conChart = (
            <Chart
              className="graph"
              chartType="BarChart"
              loader={<div>Loading Chart</div>}
              data={dataArray}
              options={{
                chartArea: { width: '55%' },
                legend: { position: "none" },
                animation: {
                  duration: 2000,
                  easing: 'out',
                  startup: true,
                },
                hAxis: {
                  format: 'short'
                }
              }}
            />
          );
        } else {
          conChart = <span>Insufficient Data. Chart could not be rendered</span>;
        }
      } else {
        conChart = <span>Insufficient Data. Chart could not be rendered</span>;
      }

      if (topDeaths && topDeaths.length > 0) {
        const dataArray = [];
        topDeaths.forEach(elem => {
          if (elem.deaths) {
            if (param && param === 'US') {
              dataArray.push([elem.state, elem.deaths, '#ff0000']);
            } else {
              dataArray.push([elem.country, elem.deaths, '#ff0000']);
            }
          }
        });

        if (dataArray.length > 0) {
          if (param && param === 'US') {
            dataArray.unshift(['State', 'Cases', { role: 'style' }]);
          } else {
            dataArray.unshift(['Country', 'Cases', { role: 'style' }]);
          }
        }

        if (dataArray.length > 2) {
          detChart = (
            <Chart
              className="graph"
              chartType="BarChart"
              loader={<div>Loading Chart</div>}
              data={dataArray}
              //   [
              //   ['Country', 'Cases', { role: 'style' }],
              //   [topDeaths[0].displayName, topDeaths[0].totalDeaths, "#ff0000"],
              //   [topDeaths[1].displayName, topDeaths[1].totalDeaths, "#ff0000"],
              //   [topDeaths[2].displayName, topDeaths[2].totalDeaths, "#ff0000"]
              // ]}
              options={{
                chartArea: { width: '55%' },
                legend: { position: "none" },
                animation: {
                  duration: 2000,
                  easing: 'out',
                  startup: true,
                },
                hAxis: {
                  format: 'short'
                }
              }}
            />
          );
        } else {
          detChart = <span>Insufficient Data. Chart could not be rendered</span>;
        }
      } else {
        detChart = <span>Insufficient Data. Chart could not be rendered</span>;
      }

      if (topRecovered && topRecovered.length > 0) {
        const dataArray = [];
        topRecovered.forEach(elem => {
          if (elem.recovered) {
            if (param && param === 'US') {
              dataArray.push([elem.state, elem.recovered, '#4caf50']);
            } else {
              dataArray.push([elem.country, elem.recovered, '#4caf50']);
            }

          }
        });

        if (dataArray.length > 0) {
          if (param && param === 'US') {
            dataArray.unshift(['State', 'Cases', { role: 'style' }]);
          } else {
            dataArray.unshift(['Country', 'Cases', { role: 'style' }]);
          }
        }

        if (dataArray.length > 2) {
          recChart = (
            <Chart
              className="graph"
              chartType="BarChart"
              loader={<div>Loading Chart</div>}
              data={dataArray}
              //   [
              //   ['Country', 'Cases', { role: 'style' }],
              //   [topRecovered[0].displayName, topRecovered[0].totalRecovered, "#4caf50"],
              //   [topRecovered[1].displayName, topRecovered[1].totalRecovered, "#4caf50"],
              //   [topRecovered[2].displayName, topRecovered[2].totalRecovered, "#4caf50"]
              // ]}
              options={{
                chartArea: { width: '55%' },
                legend: { position: "none" },
                animation: {
                  duration: 2000,
                  easing: 'out',
                  startup: true,
                },
                hAxis: {
                  format: 'short'
                }
              }}
            />
          );
        } else {
          recChart = <span>Insufficient Data. Chart could not be rendered</span>;
        }

      } else {
        recChart = <span>Insufficient Data. Chart could not be rendered</span>;
      }
    }

    const dashboardColumns = (this.props.param && this.props.param === 'US') ? usaColumns : worldColumns;

    return (
      <React.Fragment>
        <div className="insight--wrapper">
          <div className="insight--chartwrapper">
            <div>
              <h2>Confirmed Insights</h2>
              {conChart}
            </div>

            <div>
              <h2>Deaths Insights</h2>
              {detChart}
            </div>

            <div>
              <h2>Recovered Insights</h2>
              {recChart}
            </div>
          </div>

        </div>
        <DataGrid isClickable={param ? false : true} title={param ? 'ALL STATES' : 'ALL COUNTRIES'} columns={dashboardColumns} data={this.state.data} />
      </React.Fragment>
    );
  }
}

export default Insight;